<template>
<v-footer app fixed dark color="light-blue darken-3">
  <span>{{ credit }}</span>
  <v-spacer></v-spacer>
  <span>ver {{ ver }}</span>
</v-footer>
</template>

<script>
export default {
  data() {
    return {
      ver: require('../../package.json').version,
      credit: '© 2021 kin-kagi, inc.'
    }
  },
  props: {}
}
</script>

<style>
footer {
  padding-left: 10px;
  padding-right: 10px;
  font-size: 12px;
}
</style>
